import { render, staticRenderFns } from "./deliveryList.vue?vue&type=template&id=0c09407e&scoped=true&"
import script from "./deliveryList.vue?vue&type=script&lang=js&"
export * from "./deliveryList.vue?vue&type=script&lang=js&"
import style0 from "./deliveryList.vue?vue&type=style&index=0&id=0c09407e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09407e",
  null
  
)

export default component.exports